/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SenderSummary } from './SenderSummary';
import {
    SenderSummaryFromJSON,
    SenderSummaryFromJSONTyped,
    SenderSummaryToJSON,
    SenderSummaryToJSONTyped,
} from './SenderSummary';

/**
 * 
 * @export
 * @interface SenderListResponse
 */
export interface SenderListResponse {
    /**
     * 
     */
    senders: Array<SenderSummary>;
}

/**
 * Check if a given object implements the SenderListResponse interface.
 */
export function instanceOfSenderListResponse(value: object): value is SenderListResponse {
    if (!('senders' in value) || value['senders'] === undefined) return false;
    return true;
}

export function SenderListResponseFromJSON(json: any): SenderListResponse {
    return SenderListResponseFromJSONTyped(json, false);
}

export function SenderListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'senders': ((json['senders'] as Array<any>).map(SenderSummaryFromJSON)),
    };
}

export function SenderListResponseToJSON(json: any): SenderListResponse {
    return SenderListResponseToJSONTyped(json, false);
}

export function SenderListResponseToJSONTyped(value?: SenderListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'senders': ((value['senders'] as Array<any>).map(SenderSummaryToJSON)),
    };
}

